"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiListSearchService = exports.FilterState = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var modal_service_1 = require("../components/modal/modal.service");
var index_1 = require("./index");
var SEARCH_DELAY = 200;
var FilterState = /** @class */ (function () {
    function FilterState() {
    }
    FilterState.prototype.setFilter = function (value) {
        this.filter = value;
    };
    FilterState.prototype.hasFilter = function () {
        return (this.filter != null && this.filter.trim().length > 0);
    };
    FilterState.prototype.clear = function () {
        this.filter = null;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], FilterState.prototype, "filter", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FilterState.prototype, "setFilter", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FilterState.prototype, "clear", null);
    return FilterState;
}());
exports.FilterState = FilterState;
var MultiListSearchService = /** @class */ (function () {
    function MultiListSearchService(delay) {
        if (delay === void 0) { delay = SEARCH_DELAY; }
        var _this = this;
        this.__priority = 100;
        this.filtering = false;
        this.inputfilterState = new FilterState();
        this.filterState = new FilterState();
        this.searchTask = new core_shared_1.IkeDelayedTask(function () { return _this.search(); }, delay);
    }
    MultiListSearchService.prototype.init = function () {
        var _this = this;
        (0, mobx_1.reaction)(function (_) { return _this.inputfilterState.filter; }, function (_) { return _this.searchTask.delay(); });
        (0, mobx_1.reaction)(function (_) { return index_1.Services.Department.current; }, function (_) { return _this.reset(); });
    };
    MultiListSearchService.prototype.reset = function () {
        this.inputfilterState.clear();
        this.filterState.clear();
    };
    MultiListSearchService.prototype.search = function () {
        if (!this.inputfilterState.hasFilter()) {
            this.filterState.setFilter(this.inputfilterState.filter);
            this.filtering = false;
            return;
        }
        this.filtering = true;
        modal_service_1.ModalService.view();
        this.filtering = false;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], MultiListSearchService.prototype, "filtering", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], MultiListSearchService.prototype, "search", null);
    return MultiListSearchService;
}());
exports.MultiListSearchService = MultiListSearchService;
//# sourceMappingURL=multi.list.search.service.js.map